<template>
    <div class="info-container">
      <form
        id="convert_form"
        name="edit-campaign-form"
      >
        <input type="hidden" name="_token" :value="csrf">

        <!-- <input type="hidden" name="campaignId" value="" id="editCampaignId"> -->
        <div class="row mt-4">
            <div class="form-group col-md-10">
              <label class="required-label">CAMPAIGN NAME</label>
              <input
                class="form-control col-md-6"
                type="text"
                id="campaign_name"
                placeholder="Your Campaign Name"
                name="campaignName"
                v-model="campaignForm.campaignName"
                :readonly="isSubmitting"
                required
              >
            </div>
        </div>

        <div class="row mt-4">
            <div class="form-group col-md-10">
              <label class="required-label">CAMPAIGN DATE</label>
                <div class="row">
                  <input
                    class="form-control col-md-4"
                    type="date"
                    id="campaign_start_date"
                    placeholder="Start Date"
                    name="campaignStartDate"
                    v-model="campaignForm.campaignStartDate"
                    :readonly="isSubmitting"
                    required
                  >

                  <span class="col-md-1">TO</span>

                  <input
                    class="form-control col-md-4"
                    type="date"
                    id="campaign_end_date"
                    placeholder="End Date"
                    name="campaignEndDate"
                    v-model="campaignForm.campaignEndDate"
                    :readonly="isSubmitting"
                    required
                  >
              </div>
            </div>
        </div>

        <div class="row mt-4">
          <div class="form-group col-md-10">
            <label class="required-label">DESCRIPTION</label>
            <textarea
              class="form-control"
              id="campaign_desc"
              name="campaignDesc"
              v-model="campaignForm.campaignDesc"
              :readonly="isSubmitting"
              required
            ></textarea>
          </div>
        </div>

        <div class="row mt-4">
            <div class="form-group col-md-10">
              <label class="required-label">BACKGROUND IMAGE (180x180)</label>
                <div class="upload-btn-wrapper">
                    <input
                        type="file"
                        name="campaign_background_image"
                        id="campaign_background_image"
                        ref="file1"
                        @change="handleFileUpload('bg')"
                        accept="image/*"
                    ></input>
                </div>
            </div>
        </div>

        <div class="row mt-4">
            <div class="form-group col-md-10">
              <label class="required-label">THUMBNAIL IMAGE (60x60)</label>
                <div class="upload-btn-wrapper">
                    <input
                        type="file"
                        name="campaign_thumbnail_image"
                        id="campaign_thumbnail_image"
                        ref="file2"
                        @change="handleFileUpload('thumbnail')"
                        accept="image/*"
                    ></input>
                </div>
            </div>
        </div>

        <div class="row mt-4">
            <div class="form-group col-md-10">
              <label class="required-label">CAMPAIGN BACKGROUND COLOR</label>
              <input
                class="form-control col-md-6"
                type="text"
                id="campaign_background_color"
                placeholder="eg. #fffff"
                name="campaignBackgroundColor"
                v-model="campaignForm.campaignBackgroundColor"
                :readonly="isSubmitting"
                required
              >
            </div>
        </div>

        <div class="row mt-4" id="custom_field_row">
             <div class="form-group col-md-10">
                <label class="required-label">CUSTOM FIELDS</label>
            </div>
        </div>

        <div class="row mt-2" v-for="n in initial_custom_field" id="data_row">

            <input
              class="form-control col-md-3"
              type="text"
              placeholder="Label"
              v-model="customField[n-1].campaignFieldLabel"
              :readonly="isSubmitting"
              required
            >

            <select
                class="form-control col-md-2"
                v-model="customField[n-1].campaignFieldType"
                required>
                <option disabled value="" selected>CHOOSE TYPE</option>
                <option
                    v-for="item in field_type"
                    :key="item.key"
                    :value="item.key">
                    {{ item.value }}
                </option>
            </select>

            <input
              class="form-control col-md-1"
              type="text"
              placeholder="Data Length"
              v-model="customField[n-1].campaignFieldLength"
              :readonly="isSubmitting"
              required
            >
            <input
              class="form-control col-md-2"
              type="text"
              placeholder="Default Value"
              v-model="customField[n-1].campaignFieldDefault"
              :readonly="isSubmitting"
              required
            >
            <a class="col-md-1 text-danger" @click="removeRow(n)">
                <i class="fa fa-times"></i>
            </a>
        </div>

        <div class="row mt-2">
            <button
              id="add_new_row"
              type="button"
              class="justify-center btn btn-secondary btn-sm btn-block"
              @click="addNewRow"
              :disabled="isSubmitting"
            >
            ADD NEW CUSTOM FIELD
            </button>
        </div>

        <div v-if="errorMessage != ''" class>{{ errorMessage }}</div>

        <div class="mt-4 mb-4 justify-center text-center">
            <button
              id="submit_button"
              class="btn btn-blue"
              @click="submitForm"
              :disabled="isSubmitting"
            >SUBMIT</button>
        </div>

      </form>
    </div>
</template>

<script>
// Terribly sorry for this hack.. Gotta make sure this stuff is done
// Gives ability to change the vue data from front
import axios from 'axios'

export default {
  // Note: data-cards, data-f-name and data-l-name becomes camel case in props
  props: [
    "dataActionUrl",
    "dataId",
    "dataName",
    "dataDesc",
    "dataBanner",
    "dataThumbnail",
    "dataStartDate",
    "dataEndDate",
    "dataCustomField",
    "dataBgColor",
    "dataCustomCount"
  ],

  data() {

      let query = JSON.parse(this.dataCustomField);

      let array = [];
      //console.log("first"+ query);
      query.forEach(function(e) {
          array.push(e);
      });

      return {
          csrf: null,
          isSubmitting: false,
          errorMessage: '',
          action_url: this.dataActionUrl,
          selectId: this.dataId,
          query: this.dataQuery,
          campaignForm: {
              campaignId:this.dataId,
              campaignName:this.dataName,
              campaignStartDate:this.dataStartDate,
              campaignEndDate:this.dataEndDate,
              campaignDesc:this.dataDesc,
              campaignCustomField:[],
              campaignBanner:this.dataBanner,
              campaignThumbnail:this.dataThumbnail,
              campaignBackgroundColor:this.dataBgColor
          },
          customField: array,
          field_type:[
             { key: 'integer', value: 'Integer' },
             { key: 'decimal', value: 'Decimal' },
             { key: 'text', value: 'Text' },
             { key: 'rich_text', value: 'Rich Text' },
             { key: 'telephone', value: 'Telephone' },
             { key: 'image', value: 'Image' },
             { key: 'dropdown', value: 'Dropdown' }
           ],
          initial_custom_field: this.dataCustomCount
      };
  },
  mounted()
  {
      let csrfElement = document.querySelector('meta[name="csrf-token"]')

      if (csrfElement.getAttribute("content"))
      {
        this.csrf = csrfElement.getAttribute("content");
      }
  },

  methods: {

    onClose: function() {
      this.selectedCard = null;
      this.isSelected = false;
    },

    selectType:function(n, item)
    {
        this.$nextTick(function()
        {
             this.customField[n].campaignFieldType = item;
        });
    },

    addNewRow:function()
    {
        this.initial_custom_field = parseInt(this.initial_custom_field) + 1;

        let newjson = {
            campaignFieldLabel: '',
            campaignFieldType: '',
            campaignFieldLength: 0,
            campaignFieldDefault: '',
            campaignFieldID: this.initial_custom_field
        };

        this.customField.push(newjson);

        console.log("add"+JSON.stringify(this.customField));
    },

    removeRow: function (n)
    {
        let compactArray = [];

        this.initial_custom_field = parseInt(this.initial_custom_field) - 1;

        delete this.customField[n];

        let array = this.customField;

        for (var i in array)
        {
            compactArray.push(array[i]);
        }

        this.customField = compactArray;

        // console.log("remove"+JSON.stringify(this.customField));
    },

    submitForm: function() {
      this.isSubmitting = true;

      this.campaignForm.campaignCustomField = this.customField;

      // console.log("special field"+JSON.stringify(this.campaignForm.campaignCustomField,true));

      this.commitSubmit();
    },

    handleFileUpload(type)
    {
        if(type == 'bg')
        {
            this.file = this.$refs.file1.files[0];

            this.campaignForm.campaignBanner = this.file;
        } else {
            this.file = this.$refs.file2.files[0];

            this.campaignForm.campaignThumbnail = this.file;
        }

        console.log(self.campaignForm.campaingBanner);
    },

    commitSubmit:function(){
      let url = this.action_url;

         if(this.campaignForm.campaignName.length < 1)
         {
             this.isSubmitting = false;
             this.errorMessage = 'Campaign Name must be filled';

         } else if(this.campaignForm.campaignDesc.length < 1)
         {
             this.isSubmitting = false;
             this.errorMessage = 'Campaign Description must be filled';
         }
         else if(this.campaignForm.campaignStartDate == '')
         {
             this.isSubmitting = false;
             this.errorMessage = 'Campaign Start Date must be filled';
         }
         else if(this.campaignForm.campaignEndDate == '')
         {
             this.isSubmitting = false;
             this.errorMessage = 'Campaign End Date must be filled';
         } else {
             const config = { headers: { 'Content-Type': 'multipart/form-data' } };

             let data = new FormData();

             data.append('campaignName',this.campaignForm.campaignName)
             data.append('campaignDesc', this.campaignForm.campaignDesc);
             data.append('campaignStartDate', this.campaignForm.campaignStartDate);
             data.append('campaignEndDate', this.campaignForm.campaignEndDate);
             data.append('campaignCustomField', this.campaignForm.campaignCustomField);
             data.append('campaignThumbnail', this.campaignForm.campaignThumbnail);

             axios.post(url, this.campaignForm, data, config).then(response => {
                  console.log(response.data.message);

                 if(response.data.status == true)
                 {
                     this.isSubmitting = false;
                     this.onClose();
                 }
               }).catch(error => {
                   console.log(error.response.data.message);
                   this.isSubmitting = false;
                   this.errorMessage = error.response.data.message;

                   if(error.response.data.redirect_url != undefined)
                   {
                       window.location.href = error.response.data.redirect_url;
                   }
              });
         }
      }
  },
  computed: {
    // },
    // mounted() {
    //   // vm.$forceUpdate();
    //   // console.log(this.parseObject);
  }
};
</script>
